import { RouteObject } from "react-router-dom";

import { ADMIN_ROUTES } from "../../routes";

export const AdminNoPaddingRoutes: RouteObject[] = [
  {
    path: ADMIN_ROUTES.BillingMetrics,
    lazy: async () => {
      const { BillingMetricsOverviewRoute } =
        await import("@src/features/admin/pages/billing/metrics/BillingWorkflowTrace.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.BillingMetrics}
            adminOnly={true}
            isEnabled={() => true}
            children={BillingMetricsOverviewRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.BillingMetricsCommand,
    lazy: async () => {
      const { BillingMetricsCommandRoute } =
        await import("@src/features/admin/pages/billing/metrics/BillingWorkflowTrace.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.BillingMetricsCommand}
            adminOnly={true}
            isEnabled={() => true}
            children={BillingMetricsCommandRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.AgenticLogicStats,
    lazy: async () => {
      const { AgenticLogicStatsRoute } =
        await import("@src/features/admin/pages/agentic-logic-stats/AgenticLogicStats.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.AgenticLogicStats}
            isEnabled={({ isAdmin }) => isAdmin}
            children={AgenticLogicStatsRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.ShippingProviderStats,
    lazy: async () => {
      const { ShippingProviderStatsRoute } =
        await import("@src/features/admin/pages/shipping-provider-stats/ShippingProviderStats.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.ShippingProviderStats}
            isEnabled={({ isAdmin }) => isAdmin}
            children={ShippingProviderStatsRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.AdminOrgDetail,
    lazy: async () => {
      const { AdminOrgDetailRoute } =
        await import("@src/features/admin/pages/orgs/OrgDetail.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.AdminOrgDetail}
            adminOnly={true}
            isEnabled={() => true}
            children={AdminOrgDetailRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.AdminAgencyDetail,
    lazy: async () => {
      const { AdminAgencyDetailRoute } =
        await import("@src/features/admin/pages/agencies/detail/AgencyDetail.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.AdminAgencyDetail}
            adminOnly={true}
            isEnabled={() => true}
            children={AdminAgencyDetailRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.BillingSupportCommand,
    lazy: async () => {
      const { BillingSupportCommandRoute } =
        await import("@src/features/admin/pages/billing/support/commands/SupportCommandDetail.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.BillingSupportCommand}
            adminOnly={true}
            isEnabled={() => true}
            children={BillingSupportCommandRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.BillingWorkflowTrace,
    lazy: async () => {
      const { BillingWorkflowTraceRedirect } =
        await import("@src/features/admin/pages/billing/metrics/BillingWorkflowTrace.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.BillingWorkflowTrace}
            adminOnly={true}
            isEnabled={() => true}
            children={BillingWorkflowTraceRedirect}
          />
        ),
      };
    },
  },
];
